// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.sRcWg{margin:20px auto;padding:0 0 40px;width:80%}@media(max-width: 991px){.sRcWg{width:90%}}@media screen and (min-width: 992px){.sRcWg{max-width:1073px}}@media screen and (min-width: 1439px){.sRcWg{max-width:1200px}}@media only screen and (max-width: 767px){.q15Or{width:100%}}@media(max-width: 767px)and (orientation: landscape){.q15Or{width:90%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "sRcWg",
	"fullWidthOnMobile": "q15Or"
};
module.exports = ___CSS_LOADER_EXPORT___;
